/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the percentage by 100 and multiply by the number. For example, 20% of 50 is (20 ÷ 100) × 50 = 10.`)
};

const es_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide el porcentaje entre 100 y multiplícalo por el número. Por ejemplo, el 20% de 50 es (20 ÷ 100) × 50 = 10.`)
};

const de_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile den Prozentsatz durch 100 und multipliziere mit der Zahl. Zum Beispiel sind 20 % von 50 gleich (20 ÷ 100) × 50 = 10.`)
};

const nl_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel het percentage door 100 en vermenigvuldig met het getal. Bijvoorbeeld, 20% van 50 is (20 ÷ 100) × 50 = 10.`)
};

const fr_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez le pourcentage par 100 puis multipliez par le nombre. Par exemple, 20 % de 50 donne (20 ÷ 100) × 50 = 10.`)
};

const it_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi la percentuale per 100 e moltiplica per il numero. Ad esempio, il 20% di 50 è (20 ÷ 100) × 50 = 10.`)
};

const pt_br2_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a porcentagem por 100 e multiplique pelo número. Por exemplo, 20% de 50 é (20 ÷ 100) × 50 = 10.`)
};

const pt_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a percentagem por 100 e multiplique pelo número. Por exemplo, 20% de 50 é (20 ÷ 100) × 50 = 10.`)
};

const ja_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントを100で割り、その数を掛けます。例えば50の20%は(20 ÷ 100) × 50 = 10です。`)
};

const zh_pct_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将百分比除以 100 再乘以该数值。例如，50 的 20% 是 (20 ÷ 100) × 50 = 10。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq1_a", locale)
	if (locale === "en") return en_pct_hub_faq1_a(inputs)
	if (locale === "es") return es_pct_hub_faq1_a(inputs)
	if (locale === "de") return de_pct_hub_faq1_a(inputs)
	if (locale === "nl") return nl_pct_hub_faq1_a(inputs)
	if (locale === "fr") return fr_pct_hub_faq1_a(inputs)
	if (locale === "it") return it_pct_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq1_a(inputs)
	if (locale === "pt") return pt_pct_hub_faq1_a(inputs)
	if (locale === "ja") return ja_pct_hub_faq1_a(inputs)
	return zh_pct_hub_faq1_a(inputs)
};